<template>
  <coverage-page
    :customPageControl="pageControl"
    :customDefaultForm="defaultForm"
    :customNeedValidate="needValidate"
  />
</template>
<script>
import { mapGetters } from "vuex";
import CoveragePage from "./components/CoveragePage.vue";
import { commonMixin } from "@/mixins/common";
export default {
  mixins: [commonMixin],
  name: "DreadDiseaseBenefit",
  components: {
    CoveragePage,
  },
  data() {
    return {
      pageControl: {
        pageName: "重大疾病",
        pageBlock: ["periodMulti", "formulaMulti", "maxCustom"],
        showUpper: true,
        coverageItemsSortSeq: true,
      },
      defaultForm: {
        unit_lower: 2,
        formulaType: 6,
        benefitTypeId: "2",
      },
      needValidate: {
        period_upper: false,
      },
    };
  },
  computed: {
    ...mapGetters(["BaseUrl"]),
  },
  watch: {},
  methods: {},
  mounted() {},
};
</script>
